export default __webpack_public_path__ + "static/media/write.996b75fe.svg";